<table mat-table [dataSource]="listPrestacionesRechasadasAprobadas">
  <ng-container matColumnDef="Prestacion">
    <th mat-header-cell *matHeaderCellDef>Prestación</th>
    <td mat-cell *matCellDef="let element" class="truncate-cell" title="{{element?.Prestacion}}">
      {{element?.Prestacion}} </td>
  </ng-container>
  <ng-container matColumnDef="Prestador">
    <th mat-header-cell *matHeaderCellDef>Prestador</th>
    <td mat-cell *matCellDef="let element" class="truncate-cell" title="{{element?.Prestador}}">
      {{element?.Prestador }} </td>
  </ng-container>
  <ng-container matColumnDef="Desde">
    <th mat-header-cell *matHeaderCellDef>Desde</th>
    <td mat-cell *matCellDef="let element"> {{element.FechaDesde}} </td>
  </ng-container>
  <ng-container matColumnDef="Hasta">
    <th mat-header-cell *matHeaderCellDef>Hasta</th>
    <td mat-cell *matCellDef="let element"> {{element.FechaHasta}} </td>
  </ng-container>
  <ng-container matColumnDef="Sesiones">
    <th mat-header-cell *matHeaderCellDef>Sesiones o Km</th>
    <td mat-cell *matCellDef="let element" class="truncate-cell texto-centrado"
      title="{{element?.Cantidad}} ({{element.TipoCantidad}})"> {{element.Cantidad}} ({{element.TipoCantidad}})</td>
  </ng-container>
  <ng-container matColumnDef="Estado">
    <th mat-header-cell *matHeaderCellDef>Estado</th>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="element.Estado == 'NO APROBADA'" class="solicitud-rechazada">
        <img src="assets/icons/solicitudes-aprobadas-rechazadas/solicitud-rechazada.svg" />
        <span>RECHAZADA</span>
      </div>
      <div *ngIf="element.Estado == 'PRE APROBADA'" class="solicitud-aprobada">
        <img src="assets/icons/solicitudes-aprobadas-rechazadas/solicitud-aprobada.svg" />
        <span>PRE APROBADA</span>
      </div>
      <div *ngIf="element.Estado == 'APROBADA'" class="solicitud-aprobada">
        <img src="assets/icons/solicitudes-aprobadas-rechazadas/solicitud-aprobada.svg" />
        <span>APROBADA</span>
      </div>
      <div *ngIf="element.Estado == 'BAJA PRESTADOR'" class="solicitud-aprobada">
        <img src="assets/icons/solicitudes-aprobadas-rechazadas/solicitud-aprobada.svg" />
        <span>APROBADA</span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="Link">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <a (click)="irADetalle(element)" class="link-grilla-solicitud">Más información</a>
    </td>
  </ng-container>
  <ng-container matColumnDef="Descarga">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button (click)="descargarPdf(element)" class="btn-descarga-icon" [disabled]="isLoading(element)" *ngIf="element.Estado == 'PRE APROBADA' || element.Estado == 'APROBADA'" >
        <mat-spinner *ngIf="isLoading(element)" diameter="20" strokeWidth="2"></mat-spinner>
        <img *ngIf="!isLoading(element)" src="assets/icons/file-download.svg" alt="Descargar PDF" />
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columndefs"></tr>
  <tr mat-row *matRowDef="let row; columns: columndefs;"></tr>
</table>